import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { IndustryAcronymizePipe } from './industry-acronymize.pipe';
import { HumanizePipe } from './humanize.pipe';
import { RadioAccessTechPipe } from './radio-access-tech.pipe';
import { TranslateFallbackPipe } from './translate-fallback.pipe';
import { TranslateRadiusSessionEvent } from './translate-radius-session-event.pipe';
import { DefaultDatePipe } from './default-date.pipe';
import { ConnectionIpAddressPipe } from './connection-ip-address.pipe';
import { RemovePrefixPipe } from './remove-prefix.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [DatePipe, HumanizePipe],
    declarations: [IndustryAcronymizePipe, HumanizePipe, RadioAccessTechPipe, TranslateFallbackPipe, TranslateRadiusSessionEvent, DefaultDatePipe, ConnectionIpAddressPipe, RemovePrefixPipe],
    exports: [IndustryAcronymizePipe, HumanizePipe, RadioAccessTechPipe, TranslateFallbackPipe, TranslateRadiusSessionEvent, DefaultDatePipe, ConnectionIpAddressPipe, RemovePrefixPipe]
})
export class SharedPipesModule { }
